// Test switch between the free data stack (yfinance estimates + SEC EDGAR history), the
// paid one (FMP) and our own projections on SEC EDGAR ("own", «Nuestro»). Per browser; sent to the backend on every request as
// `X-Data-Source` (see api.js), so any endpoint can honour it. Nothing chosen → no header:
// the server applies its default source («Nuestro», `default` in /data-source/status).
const KEY = "vs.dataSource";
export const DATA_SOURCES = ["free", "fmp", "own"];

export function getDataSource() {
    try {
        const v = window.localStorage.getItem(KEY);
        return DATA_SOURCES.includes(v) ? v : null;
    } catch {
        return null;
    }
}

export function setDataSource(v) {
    try { window.localStorage.setItem(KEY, v); } catch { /* ignore */ }
}

// The company's payload asked for «Nuestro» (or «Pago») but that source couldn't serve it
// (no official figures): no Ratio Compra/Venta («sin datos suficientes»), like the ficha.
export function sourceUnavailable(data) {
    const ds = data?.data_source;
    return !!ds && (ds.requested === "own" || ds.requested === "fmp") && ds.used !== ds.requested;
}
